// Contas a receber da líder.
// Cada linha é um negócio num mês. Base = o que a agência recebeu nesse mês nesse negócio,
// menos o que pagámos a outras agências (referências e partilhas). Comissão da líder = base x percentagem.
// O fixo mensal soma-se; o IVA (23%) sobe o total a faturar.
import { r2 } from "./ComRec";

export const IVA_LIDER = 23;
const num = (v) => Number(v || 0);
export const mesDe = (d) => String(d || "").slice(0, 7);
export const mesDia1 = (m) => m + "-01";

// Valor em vigor num mês: o registo mais recente cuja data de início não passa desse mês
export function vigente(historico = [], tipo, mes) {
  const h = historico.filter((x) => x.tipo === tipo && mesDe(x.vigente_desde) <= mes).sort((a, b) => String(b.vigente_desde).localeCompare(String(a.vigente_desde)) || String(b.created_at || "").localeCompare(String(a.created_at || "")));
  return h.length ? num(h[0].valor) : 0;
}

// Percentagem de uma linha: negócio+mês, depois negócio, depois mês, depois a geral
export function percentagemLinha({ config = [], ajustes = [], mes, negocioId }) {
  const acha = (m, n) => ajustes.find((a) => (a.mes ? mesDe(a.mes) : null) === m && (a.negocio_id || null) === n);
  let a;
  if (negocioId && (a = acha(mes, negocioId))) return { pct: num(a.percentagem), origem: "negocio_mes" };
  if (negocioId && (a = acha(null, negocioId))) return { pct: num(a.percentagem), origem: "negocio" };
  if ((a = acha(mes, null))) return { pct: num(a.percentagem), origem: "mes" };
  return { pct: vigente(config, "percentagem", mes), origem: "geral" };
}

// linhas: resultado de juntarRecebimentos (uma por recebimento). pagamentos: pagamentos às outras agências.
export function linhasLider({ linhas = [], pagamentos = [], config = [], ajustes = [], recebido = [] }) {
  const grupos = new Map();
  linhas.forEach((x) => {
    const mes = x.mesRep || mesDe(x.dataAg);
    if (!mes) return;
    const chave = x.r.negocio_id || x.r.referencia_id || x.id;
    const k = mes + "|" + chave;
    const g = grupos.get(k) || { key: k, mes, negocioId: x.r.negocio_id || null, referenciaId: x.r.referencia_id || null, id: x.id, imovel: x.imovel, consultores: new Set(), valorAgencia: 0, rendimentos: new Set() };
    g.valorAgencia += x.valorAg; if (x.consultorNome) g.consultores.add(x.consultorNome); g.rendimentos.add(x.tipo);
    grupos.set(k, g);
  });
  return [...grupos.values()].map((g) => {
    const deducoes = g.negocioId ? r2(pagamentos.filter((p) => !p.deleted_at && p.negocio_id === g.negocioId && mesDe(p.data_pagamento) === g.mes).reduce((s, p) => s + num(p.valor), 0)) : 0;
    const base = Math.max(0, r2(g.valorAgencia - deducoes));
    const { pct, origem } = percentagemLinha({ config, ajustes, mes: g.mes, negocioId: g.negocioId });
    const comissao = r2(base * pct / 100);
    const ja = r2(recebido.filter((p) => !p.deleted_at && p.tipo === "comissao" && mesDe(p.mes) === g.mes && (p.negocio_id || null) === g.negocioId).reduce((s, p) => s + num(p.valor), 0));
    return { ...g, consultores: [...g.consultores].join(", "), rendimentos: [...g.rendimentos], valorAgencia: r2(g.valorAgencia), deducoes, base, pct, origem, comissao, jaRecebeu: ja, falta: Math.max(0, r2(comissao - ja)) };
  }).sort((a, b) => b.mes.localeCompare(a.mes) || String(a.id).localeCompare(String(b.id)));
}

// Totais de um mês: fixo + comissões, IVA e total a faturar, o que já recebeu e o que falta
export function resumoMes(mes, linhasDoMes, { config = [], recebido = [] }) {
  const fixo = vigente(config, "fixo_mensal", mes);
  const comissoes = r2(linhasDoMes.reduce((s, l) => s + l.comissao, 0));
  const semIva = r2(fixo + comissoes), iva = r2(semIva * IVA_LIDER / 100), totalFaturar = r2(semIva + iva);
  const fixoRec = r2(recebido.filter((p) => !p.deleted_at && p.tipo === "fixo" && mesDe(p.mes) === mes).reduce((s, p) => s + num(p.valor), 0));
  const comRec = r2(linhasDoMes.reduce((s, l) => s + l.jaRecebeu, 0));
  const jaRecebeu = r2(fixoRec + comRec);
  return { mes, fixo, fixoRecebido: fixoRec, comissoes, semIva, iva, totalFaturar, jaRecebeu, falta: Math.max(0, r2(semIva - jaRecebeu)) };
}
